import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dividend-income-calculator',
  component: () => import('../../routes/DividendIncomeCalculator.svelte'),
  card: {
    id: 'dividend-income-calculator',
    title: 'Dividend Income Calculator',
    description: 'Calculate how much capital you need to generate target passive income from dividends, with optional DRIP reinvestment growth.',
    icon: 'payments',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/dividend-income-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Dividend Income Calculator – Passive Income from Dividends',
    description: 'Free dividend income calculator. Enter your target monthly income and dividend yield to find the capital required. Model DRIP reinvestment for year-by-year growth and dividend accumulation.',
  },
};

export default meta;